import {
  Platform,
} from '@angular/cdk/platform';
import {
  of,
} from 'rxjs';

/**
 * Returns a method which takes a platform as parameter and returns true if the current platform is Android or iOS based
 */
export const isMobileDevice = () => (platform: Platform) =>
  of(platform.ANDROID || platform.IOS);
